<template>
  <div class="gmf-customer-attributes">
    <div v-for="(value, name) in attributes" :key="name" class="gmf-customer-attributes-attribute">
      <div class="gmf-subheader">{{ t('customer_attributes.' + name + '.title') || name }}: </div>
      <ul v-if="Array.isArray(value)">
        <li v-for="(v,index) in value" :key="index" class="gmf-attribute-pill">
          {{ t('customer_attributes.' + name + '.values.' + v) || v }}
        </li>
      </ul>
      <div v-else-if="typeMap[name] && typeMap[name].type === 'multilineString'" v-text="value" style="white-space: pre-wrap"></div>
      <span class="gmf-attribute-pill" v-else>{{ t('customer_attributes.' + name + '.values.' + value) || value }}</span>
    </div>
  </div>
</template>

<style>
/*
.gmf-context .gmf-customer-attributes {
  display: flex;
  gap: var(--gmf-p-3);
  flex-wrap: wrap;
}
.gmf-context .gmf-customer-attributes-attribute {
  background: var(--gmf-col-title-background);
  border-radius: 16px;
  color: var(--gmf-col-white);
  padding: var(--gmf-p-2) var(--gmf-p-4);
}
*/
.gmf-context .gmf-customer-attributes-attribute:not(:last-child) {
  margin-bottom: var(--gmf-p-3);
}

.gmf-context .gmf-customer-attributes-attribute ul {
  list-style-type: none;
  padding: 0;
  display: flex;
  gap: var(--gmf-p-2);
  flex-wrap: wrap;
}

.gmf-attribute-pill {
  background: var(--gmf-profile-attribute-pill-bg);
  color: var(--gmf-profile-attribute-pill-col);
  border-radius: 16px;
  display: inline-block;
  padding: var(--gmf-p-2) var(--gmf-p-3);
}
</style>

<script>
import callApi from '@/utils/callApi';
import state from '@/state';

export default {
  props: ['attributes'],
  data () {
    return {
      types: [],
    };
  },
  methods: {
    t: state.t,
  },
  computed: {
    typeMap () {
      const map = [];
      for (const t of this.types) {
        map[t.name] = t;
      }
      return map;
    },
  },
  async mounted () {
    const res = await callApi('GET', '/v1/client/customer-attribute-types');
    const json = await res.json();
    this.types = json.types;
  },
};

</script>
